
export const S = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,0.48)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 3000,
  },
  modal: {
    background: "#fff",
    borderRadius: 14,
    width: "95%",
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 22px",
    borderBottom: "1px solid #e2e8f0",
    flexShrink: 0,
  },
  title: { fontSize: 15, fontWeight: 700, color: "#1e3a5f" },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: 18,
    cursor: "pointer",
    color: "#94a3b8",
    padding: "2px 4px",
    lineHeight: 1,
    borderRadius: 4,
  },
  body: { padding: "18px 22px", overflowY: "auto", flex: 1 },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    padding: "12px 22px",
    borderTop: "1px solid #e2e8f0",
    flexShrink: 0,
  },

  field:    { marginBottom: 14 },
  chipRow:  { display: "flex", flexWrap: "wrap", gap: 4, marginTop: 7 },
  checkRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    marginBottom: 14,
    userSelect: "none",
  },

  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    color: "#475569",
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    paddingBottom: 8,
    marginBottom: 14,
    borderBottom: "2px solid #eff6ff",
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginBottom: 5,
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  dateInput: {
    width: "100%",
    padding: "8px 11px",
    fontSize: 13,
    borderRadius: 7,
    border: "1.5px solid #cbd5e1",
    color: "#1e293b",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  textarea: {
    width: "100%",
    padding: "8px 11px",
    fontSize: 13,
    borderRadius: 7,
    border: "1.5px solid #cbd5e1",
    color: "#1e293b",
    outline: "none",
    resize: "vertical",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },

  /* alert boxes */
  errBox: {
    background: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: 7,
    padding: "9px 13px",
    fontSize: 13,
    color: "#b91c1c",
    marginBottom: 13,
  },
  successBox: {
    background: "#f0fdf4",
    border: "1px solid #86efac",
    borderRadius: 7,
    padding: "9px 13px",
    fontSize: 13,
    color: "#15803d",
    marginBottom: 13,
  },
  infoBox: {
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 7,
    padding: "9px 13px",
    fontSize: 13,
    color: "#1d4ed8",
    marginBottom: 13,
  },
  warnBox: {
    background: "#fffbeb",
    border: "1px solid #fde68a",
    borderRadius: 7,
    padding: "9px 13px",
    fontSize: 13,
    color: "#92400e",
    marginBottom: 13,
  },

  /* buttons */
  btnPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 20px",
    borderRadius: 7,
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    lineHeight: 1.2,
  },
  btnSecondary: {
    padding: "8px 20px",
    borderRadius: 7,
    border: "1.5px solid #cbd5e1",
    background: "#fff",
    color: "#334155",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    lineHeight: 1.2,
  },
  btnDanger: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 20px",
    borderRadius: 7,
    border: "none",
    background: "#dc2626",
    color: "#fff",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    lineHeight: 1.2,
  },
};

/* ─────────────── REUSABLE COMPONENTS ─────────────── */

/** Field label */
export const FieldLabel = ({ children }) => (
  <div style={S.fieldLabel}>{children}</div>
);

/** Native <select> with consistent styling */
export const StyledSelect = ({ value, onChange, disabled, children }) => (
  <select
    value={value}
    onChange={onChange}
    disabled={disabled}
    style={{
      width: "100%",
      padding: "8px 11px",
      fontSize: 13,
      borderRadius: 7,
      border: "1.5px solid #cbd5e1",
      background: disabled ? "#f8fafc" : "#fff",
      color: disabled ? "#94a3b8" : "#1e293b",
      outline: "none",
      cursor: disabled ? "not-allowed" : "pointer",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      fontFamily: "inherit",
    }}
  >
    {children}
  </select>
);

/** Removable chip tag */
export const Chip = ({ label, onRemove }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 5,
      background: "#eff6ff",
      border: "1px solid #bfdbfe",
      borderRadius: 20,
      padding: "2px 9px",
      fontSize: 12,
      fontWeight: 500,
      color: "#1d4ed8",
      margin: "2px",
    }}
  >
    {label}
    <span
      onClick={onRemove}
      style={{
        cursor: "pointer",
        fontWeight: 700,
        fontSize: 13,
        lineHeight: 1,
        color: "#3b82f6",
      }}
    >
      ×
    </span>
  </span>
);

/** Inline loading spinner */
export const Spin = ({ size = 13, light = false }) => (
  <>
    <style>{`@keyframes __bkSpin{to{transform:rotate(360deg)}}`}</style>
    <span
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `2px solid ${light ? "rgba(255,255,255,0.3)" : "#e2e8f0"}`,
        borderTopColor: light ? "#fff" : "#2563eb",
        borderRadius: "50%",
        animation: "__bkSpin 0.65s linear infinite",
        flexShrink: 0,
        verticalAlign: "middle",
      }}
    />
  </>
);

/** Centered bigger spinner for confirm modals */
export const BigSpin = () => (
  <div style={{ textAlign: "center", padding: "22px 0" }}>
    <Spin size={28} />
    <p style={{ marginTop: 12, fontSize: 13, color: "#64748b" }}>
      Processing, please wait…
    </p>
  </div>
);